// extracted by mini-css-extract-plugin
module.exports = {"page":"_5DaT8K8d","breadcrumbs":"_5D1Ouk_d","edit":"_5D2fm6hj","roles":"_5D1u9jIt"};